const filterGroups = [
    {
        id: 'status',
        title: 'Status',
        localizedTitle: 'STATUS',
        type: 'checkbox',
        filters: ['available', 'unavailable', 'closed_area', 'on_area'],
    },
    {
        id: 'equipment',
        title: 'Equipment',
        localizedTitle: 'EQUIPMENT',
        type: 'equipment',
    },
    {
        type: 'date_range',
        id: 'last_free_date',
        title: 'Last Free Date',
        localizedTitle: 'LAST_FREE_DATE',
    },
    {
        type: 'date_range',
        id: 'last_cut_date',
        title: 'Last Cut Date',
        localizedTitle: 'LAST_CUT_DATE',
    },
    {
        type: 'date_range',
        id: 'earliest_empty_date',
        title: 'Earliest Date to Get Empty',
        localizedTitle: 'EARLIEST_DATE_TO_GET_EMPTY',
    },
    {
        type: 'date_range',
        id: 'earliest_return_date',
        title: 'Earliest Return Date',
        localizedTitle: 'EARLIEST_RETURN_DATE',
    },
];
export default filterGroups;
